<script>
export default {
    props: {
        active: {type: Boolean, default: false},
    },

    computed: {
        css() {
            return this.active ? 'fas fa-bookmark' : 'far fa-bookmark'
        }
    }
}
</script>

<template>
  <button class="btn btn-sm navbar-btn me-1 mb-1 c-tool-btn" :class="active ? 'text-primary' : ''"
   title="Favoriten" @click.prevent="$emit('click')">
       <i :class="css"></i>
       <span class="c-tool-btn-label">Favoriten</span>
  </button>
</template>

<style scoped>
.c-tool-btn {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
}
.c-tool-btn-label {
  font-size: 0.65rem;
  margin-top: 2px;
}
</style>
